import { render, staticRenderFns } from "./AutoSuggestMember.vue?vue&type=template&id=98fffea0&"
import script from "./AutoSuggestMember.vue?vue&type=script&lang=js&"
export * from "./AutoSuggestMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports